import React, { useState } from "react";
import {
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Row,
  Col,
} from "reactstrap";
import { Eye, EyeOff } from "react-feather";

const PartnerFormFields = ({ formData, errors, onChange, mode, partnerData }) => {
  const isReadOnly = mode === "view";
  const [showToken, setShowToken] = useState(false);

  return (
    <>
      {/* Partner Name */}
      <FormGroup>
        <Label for="name">
          Partner Name <span className="text-danger">*</span>
        </Label>
        <Input
          id="name"
          name="name"
          type="text"
          placeholder="Enter partner name"
          value={formData.name}
          onChange={(e) => onChange("name", e.target.value)}
          invalid={!!errors.name}
          disabled={isReadOnly}
        />
        <FormFeedback>{errors.name}</FormFeedback>
      </FormGroup>

      {/* Token */}
      <FormGroup>
        <Label for="token">Token</Label>
        {isReadOnly ? (
          <div className="position-relative">
            <Input
              id="token"
              name="token"
              type={showToken ? "text" : "password"}
              value={formData.token || ""}
              disabled
            />
            <button
              type="button"
              onClick={() => setShowToken((v) => !v)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
                lineHeight: 1,
              }}
              title={showToken ? "Hide token" : "Show token"}
            >
              {showToken ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        ) : (
          <>
            <Input
              id="token"
              name="token"
              type="text"
              placeholder="Enter E2 Cloud token (optional — can be set later)"
              value={formData.token}
              onChange={(e) => onChange("token", e.target.value)}
              invalid={!!errors.token}
            />
            <FormFeedback>{errors.token}</FormFeedback>
            <small className="text-muted">
              The partner can set or update their token from the Account page after logging in.
            </small>
          </>
        )}
      </FormGroup>

      {/* Status badge in view/edit mode */}
      {(mode === "edit" || mode === "view") && partnerData && (
        <FormGroup>
          <Label>Status</Label>
          <div>
            <span
              className={`badge badge-${partnerData.active !== false ? "success" : "secondary"}`}
            >
              {partnerData.active !== false ? "Active" : "Inactive"}
            </span>
          </div>
        </FormGroup>
      )}

      {/* License Information - only for create/edit mode */}
      {mode !== "view" && (
        <>
          <hr />
          <h6 className="mb-3">License Information</h6>

          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="startDate">
                  Start Date <span className="text-danger">*</span>
                </Label>
                <Input
                  id="startDate"
                  name="startDate"
                  type="date"
                  value={formData.startDate}
                  onChange={(e) => onChange("startDate", e.target.value)}
                  invalid={!!errors.startDate}
                  disabled={isReadOnly}
                />
                <FormFeedback>{errors.startDate}</FormFeedback>
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label for="endDate">
                  End Date <span className="text-danger">*</span>
                </Label>
                <Input
                  id="endDate"
                  name="endDate"
                  type="date"
                  value={formData.endDate}
                  onChange={(e) => onChange("endDate", e.target.value)}
                  invalid={!!errors.endDate}
                  disabled={isReadOnly}
                />
                <FormFeedback>{errors.endDate}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label for="level">
              License Level <span className="text-danger">*</span>
            </Label>
            <Input
              id="level"
              name="level"
              type="select"
              value={formData.level}
              onChange={(e) => onChange("level", e.target.value)}
              invalid={!!errors.level}
              disabled={isReadOnly}
            >
              <option value="SILVER">SILVER</option>
              <option value="GOLD">GOLD</option>
              <option value="PLATINUM">PLATINUM</option>
            </Input>
            <FormFeedback>{errors.level}</FormFeedback>
            <small className="text-muted">
              Select the license tier for this partner
            </small>
          </FormGroup>
        </>
      )}
    </>
  );
};

export default PartnerFormFields;
